import { render, staticRenderFns } from "./XshyList.vue?vue&type=template&id=5560979a&scoped=true"
import script from "./XshyList.vue?vue&type=script&lang=js"
export * from "./XshyList.vue?vue&type=script&lang=js"
import style0 from "./XshyList.vue?vue&type=style&index=0&id=5560979a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5560979a",
  null
  
)

export default component.exports